/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */

import React, { useState, useEffect, useRef, useImperativeHandle, } from 'react';
import MainHeader from "../../../../Shared/components/Header";
import { TextField } from "@mui/material";
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import SettingsImg from "../../../../../assets/images/icon_menus/SettingsIcon.json";
import clsx from "clsx";
import { NavLink } from "react-router-dom";
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import customStyles from "../../../../../assets/styles/customStyles";
import { Row, Col, Image, Space } from "antd";
import { useDispatch, useSelector } from "react-redux";
import AddIcon from "../../../../../assets/images/icon_actions/Add Icon.svg";
import { checkCRUDPermission, checkComponentPermission, capitalizeFirstLetter } from '../../../../../helpers/utilities';
import usePrevious from "../../../../Shared/components/Previous";
import { ListTable } from './ListTable';
import crudActions from "../../../../CRUD/redux/actions";
import DeleteModal from "../../../../Shared/components/DeleteModal";
import ClearIcon from "../../../../../assets/images/icon_actions/Clear Icon.svg";

export const BatchList = React.forwardRef((props, ref) => {
    const { roleManagement } = useSelector(state => state.authReducer);
    const { getList, getData } = useSelector(state => state.crudReducer);
    const { handleOpen, type } = props;
    const [deleteModal, setDeleteModal] = useState(false);
    const [iconAnimation, setIconAnimation] = useState(false);
    const [loadMore, setLoadMore] = useState(false);
    const [sortOrder, setSortOrder] = useState("desc");
    const [sortBy, setSortBy] = useState("id");
    const [loadMoreContent, setLoadMoreContent] = useState(false);
    const [skip, setSkip] = useState(0);
    const limit = 25;
    const [search, setSearch] = useState('');
    const classes = customStyles();
    const dispatch = useDispatch();
    const prevSearch = usePrevious(search);
    const [batchId, setBatchId] = useState('');
    const [name, setName] = useState('');
    const timeoutRef = useRef(null);
    const onDelete = (data) => {
        setDeleteModal(true);
        setBatchId(data.id);
        setName(data.batchId);
    }

    useImperativeHandle(ref, () => ({
        dispatchFilter() {
            dispatchFilter(sortBy, sortOrder);
        }
    }))

    const dispatchFilter = (sortBy, sortOrder, skip = 0) => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }

        let filter = { ["and"]: [] };
        let or = { ["or"]: [] };

        if (type === 'inbound') {
            filter['and'].push({ inBound: true });
        } else {
            filter['and'].push({ inBound: false });
        }

        if (search !== '') {
            or['or'].push({ batchId: { like: '%' + search.trim() + '%' } });
            or['or'].push({ batchStatus: { like: '%' + search.trim() + '%' } });
        }
        filter['and'].push(or);

        setSkip(skip);
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: 'batches',
            skip: skip,
            filter: {
                where: filter,
                order: sortBy + ' ' + sortOrder,
                limit: limit,
                skip: skip
            },
        });
    }

    const prevGetData = usePrevious(getData);
    useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }
        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData.length > 0) {
                    setLoadMore(true);
                    if (getData.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {
                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });
            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);

    const requestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        dispatchFilter(sortBy, sortOrder);
    }

    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFilter(sortBy, sortOrder, s);
    }

    useEffect(() => {
        if ((prevSearch !== undefined && search && search.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                dispatchFilter(sortBy, sortOrder);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    dispatchFilter(sortBy, sortOrder);
                }, 500);
            }
        }
    }, [search]);

    return <>
        <MainHeader {...props} img={SettingsImg}
            title={'Admin'} links={[{ 'label': 'Admin', 'link': '/admin' }, { 'label': 'Batch Process', 'link': '' }]} />
        <div className={clsx(classes.margin40, classes.listTableMargin)}>
            <PrimaryCard
                title={`${capitalizeFirstLetter(type)} Price List`}
                component={
                    <>
                        <Row align="middle" className={classes.marginBottom20}>
                            <Col xxl={6} xl={7} lg={8} md={10} sm={13} xs={24}>
                                {
                                    roleManagement !== '' && checkComponentPermission(`${capitalizeFirstLetter(type)} Price List`, 'Action', 'Search') &&
                                    <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation || search !== '' })}>
                                        <TextField autoComplete='one-time-code'
                                            placeholder={'Search Batch ID and Status'}
                                            type='search'
                                            value={search}
                                            className={classes.comInput}
                                            required
                                            variant={'standard'}
                                            onChange={(e) => setSearch(e.target.value)}
                                            fullWidth
                                            onFocus={() => setIconAnimation(true)}
                                            onBlur={() => setIconAnimation(false)}
                                        />
                                        <Image
                                            src={SearchIcon}
                                            preview={false}
                                        />
                                        {
                                            search && <NavLink to="#" onClick={() => setSearch('')} className={classes.searchClear}>
                                                <Image
                                                    src={ClearIcon}
                                                    preview={false}
                                                />
                                            </NavLink>
                                        }
                                    </div>
                                }
                            </Col>
                            <Col xxl={18} xl={17} lg={16} md={14} sm={11} xs={24} className={clsx(classes.textAlignRight, classes.allCustomerTop)}>
                                <div className={classes.overlFlowResponsiveDesign}>
                                    <Space direction="horizontal" align="center">
                                        {
                                            type === 'outbound' && roleManagement !== '' && checkCRUDPermission(`${capitalizeFirstLetter(type)} Price List`, 'create', 'Admin') &&
                                            <NavLink
                                                to={"#"}
                                                onClick={() => handleOpen()}
                                                className={clsx(classes.customLink)}>
                                                <Image
                                                    src={AddIcon}
                                                    preview={false}
                                                    className={clsx(classes.antImage)}
                                                /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Run Price Query</span>
                                            </NavLink>
                                        }
                                    </Space>
                                </div>
                            </Col>
                        </Row>
                        <ListTable
                            type={type}
                            search={search}
                            onDelete={(data) => onDelete(data)}
                            loadTasks={() => dispatchFilter(sortBy, sortOrder)}
                            details={getList}
                            loadMore={loadMore}
                            {...props}
                            loadMoreTask={() => loadMoreTask()}
                            loadMoreContent={loadMoreContent}
                            sortOrder={sortOrder}
                            sortBy={sortBy}
                            roleManagement={roleManagement}
                            onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)}
                        />
                    </>
                }
            />
        </div>
        <DeleteModal onClose={(v) => setDeleteModal(v)}
            id={batchId} loadTasks={() => dispatchFilter(sortBy, sortOrder)} name={name} url={'batches'}
            title={capitalizeFirstLetter(type)} visible={deleteModal} />
    </>
})